import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CvrSortDirection = "asc" | "desc" | "none";

/**
 * Redux state interface for CVR Compliance Action Report.
 *
 * @interface CvrARState
 * @property {CvrSortDirection} sortDirection - Current sort direction for the report
 * @property {string[]} availableKpis - List of available KPIs for the report
 * @property {string[]} affAbosToExpand - List of AFF-ABO identifiers to expand in tree view
 */
interface CvrARState {
  sortDirection: CvrSortDirection;
  availableKpis: string[];
  affAbosToExpand: string[];
}

export const initialState: CvrARState = {
  sortDirection: "none",
  availableKpis: [],
  affAbosToExpand: [],
};

const { actions, reducer } = createSlice({
  name: "cvrActionReport",
  initialState,
  reducers: {
    setSortDirection: (state, action: PayloadAction<CvrSortDirection>) => {
      state.sortDirection = action.payload;
    },
    toggleSortDirection: (state) => {
      if (state.sortDirection === "none" || state.sortDirection === "desc") {
        state.sortDirection = "asc";
      } else {
        state.sortDirection = "desc";
      }
    },
    setAvailableKpis: (state, action: PayloadAction<string[]>) => {
      state.availableKpis = action.payload;
    },
    setAffAbosToExpand: (state, action: PayloadAction<string[]>) => {
      state.affAbosToExpand = action.payload;
    },
  },
});

export const { setSortDirection, toggleSortDirection, setAvailableKpis, setAffAbosToExpand } = actions;

export default reducer;
